"use client";

import { Badge } from "@/components/ui/badge";
import { Label } from "@/components/ui/label";
import VerifyEmailModal from "@/components/user/verify-email";
import ChangePasswordModal from "@/components/user/change-password";
import { useAuth } from "@/context/AuthContext";

export default async function AccountPage() {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <div>
        <h3 className="font-heading text-lg font-medium">Account</h3>
        <p className="text-sm text-muted-foreground">
          Manage your account settings and security preferences.
        </p>
      </div>

      <hr className="border-t border-white/5" />

      <div className="space-y-4">
        <div className="flex flex-row items-center justify-between gap-3">
          <div className="flex w-full flex-row items-center gap-2">
            <Label htmlFor="verified">Email</Label>
            <Badge>{user!.verified ? "Verified" : "Not Verified"}</Badge>
          </div>
          {!user!.verified && <VerifyEmailModal />}
        </div>

        <div className="flex flex-row items-center justify-between gap-3">
          <Label htmlFor="password">Password</Label>
          <ChangePasswordModal />
        </div>
      </div>
    </div>
  );
}
